import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import produce from 'immer';
import AssignUnassignSearches from '../AssignUnassignSearches';
import axios from 'axios';
import CurrentAssignment from '../CurrentAssignment';
import ReactToPrint from 'react-to-print';
import { Dimmer, Loader } from 'semantic-ui-react';
import { PrintButton } from '../ProofingReport/styled';
import { PrintIcon } from 'components/ui/icons';
import { ReportData } from './types';
import Filters from './Components/Filters';
import TableWrapper from './Components/TableWrapper';

const NycReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const PrintView = styled.div`
  .totalResults {
    display: none;
  }
  @media print {
    .report {
      padding: 15px;
    }
    .totalResults {
      display: block;
    }
    .tableTwelve td {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0.2em 0.3em 0.2em 1.3em !important;
    }
  }
`;

const UsersUploadedDocs = () => {
  const [reportData, setReportData] = useState<ReportData[]>([]);
  const [showReport, setShowReport] = useState<boolean>(false);
  const [searchesToAssign, setSearchesToAssign] = useState<number[]>([]);
  const [reqString, setReqString] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [totalOrders, setTotalOrders] = useState<number>();
  const tableRef = useRef(null);

  const handleCheckChange = (searchIds: number[], checked: boolean) => {
    const newSearchesToAssign = produce(searchesToAssign, draft => {
      for (let searchId of searchIds) {
        if (checked) {
          draft.push(searchId);
        } else {
          let index = draft.findIndex(s => s === searchId);
          draft.splice(index, 1);
        }
      }
    });
    setSearchesToAssign(newSearchesToAssign);
  };

  const onSubmit = async (queryString: string) => {
    setLoading(true);
    const { data } = await axios.get(`/api/reports/UsersUploadedDocumentsReport?${queryString}`);
    const totalOrders = data.reduce((pre: any, rd: any) => {
      if (!pre.includes(rd.orderId)) {
        pre.push(rd.orderId);
      }
      return pre;
    }, []).length;
    setReportData(data);
    setTotalOrders(totalOrders);
    setLoading(false);
    setShowReport(true);
  };

  return (
    <NycReportWrapper>
      <h1>User Uploaded Reports</h1>
      <Filters setReqString={setReqString} onSubmit={onSubmit} loading={loading} />
      {showReport && (
        <div style={{ display: 'flex', gap: 20, alignItems: 'center', margin: '20px 0px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {/* <div style={{ fontWeight: 'bold', fontSize: 18 }}>{`Total Orders: ${totalOrders}`}</div> */}
            <div style={{ fontWeight: 'bold', fontSize: 18 }}>{`Total Orders: ${reportData.length}`}</div>
          </div>
          {/* <AssignUnassignSearches
            searches={searchesToAssign}
            onAssign={() => {
              onSubmit(reqString);
              setSearchesToAssign([]);
            }}
          /> */}
          <ReactToPrint
            trigger={() => (
              <PrintButton>
                <PrintIcon />
              </PrintButton>
            )}
            content={() => tableRef.current}
          />
        </div>
      )}
      {showReport && loading && <Loader active size="large" inline="centered" />}
      {showReport && (
        <div className="report" ref={tableRef}>
          <PrintView>
            <TableWrapper
              reportData={reportData}
              handleCheckChange={handleCheckChange}
              searchesToAssign={searchesToAssign}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {/* <div className="totalResults" style={{ fontWeight: 'bold', fontSize: 18 }}>
                {`Total Orders: ${totalOrders}`}
              </div> */}
              <div style={{ fontSize: 14 }}>{`Total Reports: ${reportData.length}`}</div>
            </div>
          </PrintView>
        </div>
      )}
    </NycReportWrapper>
  );
};

export default UsersUploadedDocs;
